import { MAX_SELECTABLE_SERIES } from "~/feature/chart/constants";

const selectMarket = (selections: string[], marketId: string): string[] => {
  const hasReachedLimit = selections.length >= MAX_SELECTABLE_SERIES;

  if (hasReachedLimit) {
    return [...selections.slice(1), marketId];
  }

  return [...selections, marketId];
};

const deselectMarket = (selections: string[], marketId: string): string[] => {
  const nextSelections = selections.filter((id) => id !== marketId);
  const isLastSelection = nextSelections.length === 0;

  return isLastSelection ? selections : nextSelections;
};

export const toggleMarketSelection = (
  selections: string[],
  marketId: string
): string[] =>
  selections.includes(marketId)
    ? deselectMarket(selections, marketId)
    : selectMarket(selections, marketId);
